import invalidate from '../../util/invalidate';
import mustRender from '../../util/mustRender';

function convertHeadings(chart) {
  const { sizes, data } = chart;

  let subdekPromoSizes = {};

  if (data.subdekPromo) {
    subdekPromoSizes = { ...data.subdekPromo };
  } else if (data.subdek) {
    subdekPromoSizes = { ...data.subdek };
  } else {
    subdekPromoSizes = { ...sizes.preview.headings.subdek };
  }

  let notePromoSizes = {};

  if (data.notePromo) {
    notePromoSizes = { ...data.notePromo };
  } else if (data.note) {
    notePromoSizes = { ...data.note };
  } else {
    notePromoSizes = { ...sizes.preview.headings.note };
  }

  let sourcePromoSizes = {};

  if (data.sourcePromo) {
    sourcePromoSizes = { ...data.sourcePromo };
  } else if (data.source) {
    sourcePromoSizes = { ...data.source };
  } else {
    sourcePromoSizes = { ...sizes.preview.headings.source };
  }

  return {
    title: data.title ? { ...data.title } : { ...sizes.preview.headings.title },
    dek: data.dek ? { ...data.dek } : { ...sizes.preview.headings.dek },
    subdek: data.subdek ? { ...data.subdek } : { ...sizes.preview.headings.subdek },
    note: data.note ? { ...data.note } : { ...sizes.preview.headings.note },
    source: data.source ? { ...data.source } : { ...sizes.preview.headings.source },
    date: data.date ? { ...data.date } : { ...sizes.preview.headings.date },
    xaxisTitle: data.xaxisTitle ? { ...data.xaxisTitle } : { ...sizes.preview.headings.xaxisTitle },
    yaxisTitle: data.yaxisTitle ? { ...data.yaxisTitle } : { ...sizes.preview.headings.yaxisTitle },
    slug: data.slug || chart.title,
    subdekPromo: subdekPromoSizes,
    notePromo: notePromoSizes,
    sourcePromo: sourcePromoSizes,
    chartFont: data.chartFont || 'en',
    altText: data.altText || convertAltText(data),
  };
}

function convertAltText(data) {
  const { dek, title, subdek } = data;
  const altText = { text: '', modifiedByUser: false, prevProp: null };
  if (dek?.text) {
    altText.text = dek.text;
    altText.prevProp = 'dek';
  } else if (title?.text) {
    altText.text = title.text;
    altText.prevProp = 'title';
  } else if (subdek?.text) {
    altText.text = subdek.text;
    altText.prevProp = 'subdek';
  }
  return altText;
}

function fetchHeadingsInfo(state, action) {
  if (!action.data) {
    return state;
  }
  if (action.data.status === 'success') {
    return convertHeadings(action.data.body.chart);
  }
  return state;
}

function getAltText({ currentProp, value, headings }) {
  const { altText, title, subdek } = headings;
  // if text has been deleted fallback to the next available heading
  if (altText.prevProp === currentProp && value === '' && !altText.modifiedByUser) {
    const defaultAltText = { text: '', modifiedByUser: false, prevProp: null };
    switch (altText.prevProp) {
      case 'dek':
        if (title.text || subdek.text) {
          return {
            text: title.text || subdek.text,
            modifiedByUser: false,
            prevProp: title.text ? 'title' : 'subdek',
          };
        }
        return defaultAltText;
      case 'title':
        if (subdek.text) {
          return {
            text: subdek.text,
            modifiedByUser: false,
            prevProp: 'subdek',
          };
        }
        return defaultAltText;
      default:
        return defaultAltText;
    }
  }
  // do not update alt text if it's been modified by a user or if a higher precedence headings is present.
  if (
    altText.modifiedByUser ||
    (altText.prevProp === 'dek' && currentProp !== 'dek') ||
    (altText.prevProp === 'title' && currentProp === 'subdek')
  )
    return altText;
  return { text: value, modifiedByUser: false, prevProp: currentProp };
}

function updateChart(stateTree, state, payload, prop, enabled = true) {
  const { active } = stateTree.documents;

  let activeDoc = stateTree.documents.items[active];
  activeDoc = activeDoc.setIn(['chart', 'data', 'showTooltips'], false);
  activeDoc = invalidate(activeDoc, '*', 'chart/data');
  activeDoc = activeDoc.setIn(['mustRender'], mustRender(activeDoc));

  localStorage.setItem('saved', 'false');

  switch (prop) {
    case 'slug':
    case 'chartFont':
    case 'altText':
      return { ...state, mustRender: activeDoc.mustRender, [prop]: payload };
    case 'title':
    case 'dek':
    case 'subdek':
      return {
        ...state,
        mustRender: activeDoc.mustRender,
        [prop]: { ...state[prop], text: payload, enabled },
        altText: getAltText({
          currentProp: prop,
          value: payload,
          headings: stateTree.headings,
        }),
      };
    case 'note':
    case 'notePromo':
      return {
        ...state,
        mustRender: activeDoc.mustRender,
        [prop]: {
          ...state[prop],
          text: payload,
          enabled: /^Note:?$/i.test(payload.replace(/\s/g, '')) ? false : enabled,
        },
      };
    default:
      return {
        ...state,
        mustRender: activeDoc.mustRender,
        [prop]: {
          ...state[prop],
          text: payload,
          enabled,
        },
      };
  }
}

export { fetchHeadingsInfo, updateChart, getAltText };
